import script from "./JournalGlyph.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalGlyph.vue?vue&type=script&setup=true&lang=js"

import "./JournalGlyph.vue?vue&type=style&index=0&id=34cf5aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cf5aa6"]])

export default __exports__